var contactSubmit = {
  submitButton: $('#question_submit'),
  fullNameInput: $('#question_fullName'),
  phoneInput: $('#question_phoneNumber'),
  phoneNumberError: $('#phone-number-error'),
  phoneError: false,

  init: function () {
    this.form = this.submitButton.closest('form');
    toastr.options.positionClass = 'toast-bottom-center';

    var widget = this.form.find('[data-toggle="recaptcha"]')[0];
    if (widget) {
      var widgetType = widget.getAttribute('data-type');
      var widgetSiteKey = widget.getAttribute('data-site-key');
      var widgetParameters = {
        sitekey: widgetSiteKey,
      };
      if (widgetType == 'invisible') {
        widgetParameters['callback'] = function () {
          app.submitForm(app.form.serialize());
        };
        widgetParameters['size'] = 'invisible';
      }
      var widgetId = grecaptcha.render(widget, widgetParameters);
    }

    var app = this;
    this.submitButton.on('click', function (event) {
      $('.error-messages').remove();
      if (app.form[0].checkValidity()) {
        event.preventDefault();
        if (!app.phoneError && app.checkPhoneInput()) {
          $('.error-messages').remove();
          var checkbox = $('#question_agree');
          if (checkbox.prop('checked')) {
            grecaptcha.execute(widgetId);
          } else {
            $('.form--agreement').append(
              '<span class="error-messages">' +
                checkbox.data('error') +
                '</span>'
            );
          }
        }
      }
    });

    this.fullNameInput.keyup(function () {
      $(this).val($(this).val().replace(/\d+/, ''));
    });
    this.phoneInput.keyup(function () {
      $(this).val($(this).val().replace(/\D/g, '').replace('420', ''));
      if ($(this).val().length > 9) {
        app.phoneNumberError.removeClass('is-hidden');
        app.phoneError = true;
      } else {
        app.phoneNumberError.addClass('is-hidden');
        app.phoneError = false;
      }
    });
  },
  submitForm: function (serializedForm) {
    var app = this;
    $.ajax({
      url: this.form.attr('action'),
      method: 'POST',
      data: serializedForm,
      beforeSend: function () {
        app.disableButton(true);
      },
      success: function (response) {
        if (response.ok) {
          // app.showMessage(response.message, 'success');
          window.location.replace(response.redirectUrl);
        } else {
          app.showMessage(response.message, 'warning');
        }
      },
      error: function (response) {
        app.showMessage(response.responseJSON.message, 'error');
      },
      complete: function (jqXHR, status) {
        app.enableButton();
        app.form[0].reset();
      },
    });
  },
  showMessage: function (message, type) {
    toastr[type](message);
  },
  disableButton: function () {
    this.submitButton.attr('disabled', 'disabled');
  },
  enableButton: function () {
    this.submitButton.attr('disabled', false);
  },
  checkPhoneInput: function () {
    if (this.phoneInput.val().length !== 9) {
      this.phoneNumberError.removeClass('is-hidden');
      this.phoneError = true;

      return false;
    } else {
      this.phoneNumberError.addClass('is-hidden');
      this.phoneError = false;

      return true;
    }
  },
};

// $(function () {
//   contactSubmit.init();
// });

function onloadCallback() {
  contactSubmit.init();
}
